<template>
    <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="form">
          <div class="alert alert-success" v-if="saved">
            Zapisano
          </div>
          <b-container fluid>
            <!-- Main table element -->
            <b-table
              show-empty
              stacked="md"
              striped
              :busy="isBusy"
              :items="legals"
              :fields="fields"
              class="table--legals"
              hover>

              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <template slot="name" slot-scope="row">
                <div class="form-group form-group--legals legal-header-edit" @click="toggleLegalContent(row)">
                  <input type="text" v-model="row.item.name" class="form-control form-control-lg"> <!-- :disabled="row.item.code !== 'orange'" -->
                </div>
              </template>

              <template slot="row-details" slot-scope="row">
                <p v-if="!edit">{{row.item.content}}</p>
                <textarea v-if="edit" class="content-area" @keyup="grow" @keydown="grow" @dblclick="insertMarkup($event.target, row.item)" v-model="row.item.content"></textarea>
              </template>

            </b-table>
          </b-container>
          <div class="form-footer form-footer--single">
            <button class="button-normal button-normal--cancel edit-button" @click="edit = !edit">Edytuj</button>
            <button class="button-normal button-normal--media" @click="saveLegals()">Zapisz</button>
          </div>
        </div>
      </div>
  </div>

</template>

<script>

export default {

  name: 'Legals',
  data () {

    return {

      title: 'Lista zdań prawnych',

      isBusy: false,
      saved: false,
      fields: [
        {
          key: 'name', 
          label: 'Nazwa' 
        }
      ],

      legals: [],

      edit:false,

    }

  },
  watch:{
    edit(){
      setTimeout(()=>{

        let area = document.querySelectorAll('.content-area');
        
        area.forEach(item=>{
          this.grow(item)
        })

      }, 50)
    }
  },
  methods:{

    insertMarkup(el, item) {

      if(item.code == 'own'){
      
        let newText = ' od %day_from%.%month_from%.%year_from% do %day_to%.%month_to%.%year_to% r. ';

        var start = el.selectionStart
        var end = el.selectionEnd
        var text = item.content
        var before = text.substring(0, start)
        var after  = text.substring(end, text.length)
        item.content = (before + newText + after)
        el.selectionStart = el.selectionEnd = start + newText.length
        el.focus()

      }

    },

    grow(element){

      element.target ? element = element.target : element = element
      
      element.style.height = "5px";
      element.style.height = (element.scrollHeight)+"px";
      return;

    },

    getLegals(){

      this.isBusy = true;
      const token = localStorage.getItem('auth_token');

      this.$http.get('legal-sentences/legal/sentences', {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {



          response.data.list.forEach((item, index)=>{
            item._showDetails = true;
          });
          this.legals = response.data.list;
          this.isBusy = false;

        })
        .catch(error =>{
          
          if (error.response.status === 400 || error.response.status === 401 || error.response.status === 402) {
            
            this.$router.push('/');

          } else {

            console.error(error.response);
            this.loading = false;

          }

        })

    },

    toggleLegalContent(row) {
      row.toggleDetails();
    },

    saveLegals(){
      
      this.isBusy = true;
      this.saved = false;
      const token = localStorage.getItem('auth_token');
      let i = 0;
      let count = this.legals.length;

      this.legals.forEach( (legal) => {

        i++;

        let data = {
          name: legal.name,
          content: legal.content
        }

        this.$http.put(`legal-sentences/${legal.id}`, data, {
        headers: {
                
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

        }})
        .then(response => {

            if(i == count){

              this.isBusy = false;
              this.saved = true;
              this.edit = false;
              this.getLegals();

              setTimeout(()=>{
                this.saved = false;
              }, 2000)

            }

        })
        .catch(error => {

          console.error(error.response);

        })

      });

    },

  },
  mounted(){

    this.getLegals();

  }
};
</script>

<style lang="scss">

.table--legals {

  thead {
    display: none;
  }

  td, th {

    padding: 5px 13px;
    border: none !important;

    .form-group--legals {
      margin-bottom: 0;
      text-decoration: underline;

      input {
        border: none;
      }

    }

    textarea {
      margin-bottom: 0;
      font-size: 1.4rem;
      line-height: 3rem;
      border:1px gray solid;
      background:transparent;
      min-width: 100%;
      resize: none;
      position: relative;
      overflow: hidden;
    }

    p {
      margin-bottom: 0;
      font-size: 1.4rem;
      line-height: 3rem;
      background:transparent;
      min-width: 100%;
    }

  }

  tr:nth-of-type(odd) {
    td {
      background-color: #fff !important;
    }
  }

  tr:nth-of-type(even) {
    td {
      background-color: #f5f5f5;
    }
  }

}

.form-control:disabled, .form-control[readonly] {
  background-color: transparent !important;
}

.edit-button{
  margin-right:10px;
  height:40px;
}
</style>
